<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="设备类型" prop="deviceType">
                <DeviceType v-model="deviceType" />
            </el-form-item>
        </template>
        <template slot="btns" v-if="permission('/firmware/add')">
            <el-button size="mini" type="primary" @click="handleAdd">
                新增固件
            </el-button>
        </template>
        <template slot="columns">
            <el-table-column label="终端类型" align="center" prop="productType"></el-table-column>
            <el-table-column label="设备类型名称" align="center" prop="deviceType"></el-table-column>
            <el-table-column label="版本号" align="center" prop="versionNumber"></el-table-column>
            <el-table-column label="更新时间" align="center" prop="updateTime"></el-table-column>
            <el-table-column label="操作" align="center" width="140" v-if="permission('/firmware/edit') || permission('/firmware/delete')">
                <template slot-scope="{ row }">
                    <el-link v-if="permission('/firmware/edit')" style="margin-right: 10px" :underline="false" type="primary" @click="handleEdit(row)">
                        编辑
                    </el-link>
                    <el-link v-if="permission('/firmware/delete')" style="margin-left: 10px;" :underline="false" type="danger" @click="handleDelete(row)">
                        删除
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { page, del } from "@/api/firmware/index";
import listMixin from '@/mixins/list';
import DeviceType from "@/components/DeviceType.vue";
export default {
    components: { DeviceType },
    data() {
        return {
            // 查询参数
            query: {
                deviceType: "",
                productType: "",
                pageNo: 1,
                pageSize: 10,
            },
            deviceType: [],
            deviceTypes: []
        };
    },
    mixins: [listMixin],
    watch: {
        deviceType(val) {
            if (val.length) {
                this.query.productType = val[0];
                this.query.deviceType = val[1];
            } else {
                this.query.productType = '';
                this.query.deviceType = '';
            }
        }
    },
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
            };
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        resetQuery() {
            this.deviceType = [];
            this.query = {
                deviceType: "",
                productType: "",
                pageNo: 1,
                pageSize: 10,
            };
            this.handleSearch();
        },
        handleDelete(row) {
            this.$confirm('确定删除该固件吗？', '提示', {
                type: 'warning'
            }).then(() => {
                del({ id: row.id }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success("删除成功");
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                });
            }).catch(() => { });
        },
        handleAdd() {
            this.$router.push({ path: "/firmware/form" });
        },
        handleEdit(row) {
            this.$router.push({ path: "/firmware/form", query: { id: row.id } });
        }
    },
};
</script>